<template>
    <div>
        <keyboard-events v-on:keyup="keyboardEvent"></keyboard-events>
        <div class="row">
            <div class="col-md-3">
                <filters-general ref="filtersReport"></filters-general>
            </div>
            <div class="col-md-9">
                <div class="row">
                    <div class="col-md-4 text-center"></div>
                    <div class="col-md-4 text-center">
                        <button class="btn ripple btn-primary" @click="getReportAnaquel">Generar Reporte </button>
                    </div>
                    <div class="col-md-4" v-if="showResultAnaquel">
                        <div v-if="loadfileAnaquel">
                            <img :src="'/theme/img/loads/loadfile.gif'" alt="carga archivo" height="40">
                            <p>Preparando archivo, espere...</p>
                        </div>
                        <button v-if="!loadfileAnaquel"  class="btn btn-success" type="button" @click="ExportFileAnaquel"><i class="fas fa-file-excel"></i> <i class="fe fe-download-cloud"></i><b> Descargar Excel</b></button>
                    </div>
                </div><br>
                <div class="row">
                    <div class="col-md-12">
                        <div class="text-center">
                            <div v-if="loadingGetDataAnaquel">
                                <img :src="'/theme/img/loads/loadfile.gif'" alt="carga archivo" height="40">
                                <p>Preparando información, espere...</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12" v-show="showResultAnaquel">
                        <v-client-table :data="tableDataAnaquel" :columns="columnsAnaquel" :options="optionsAnaquel" class="table-responsive" ref="tablePromociones">
                        </v-client-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "tablaAnaquel",
    data(){
        return{
            loadfileAnaquel:false,
            showResultAnaquel:false,
            loadingGetDataAnaquel: false,
            showDataAnaquel: false,
            columnsAnaquel: ['Fecha','Semana','Area','Agencia','Estado','Ciudad','Rol','Usuario','Canal','Cadena','Formato','Tienda','Fabricante','Departamento','Categoria','Participacion'],
            tableDataAnaquel: [],
            optionsAnaquel: {
                footerHeadings:false,
                filterByColumn:true,
                perPage:5,
                perPageValues: [5,10],
                filterable: ['Usuario','Tienda','Area','Formato','Canal','Cadena'],
                sortIcon:
                    { base:'fontawesome', up:'fas fa-long-arrow-alt-up', down:'fas fa-long-arrow-alt-down', is:'fas fa-sort' }
                ,
                listColumns: {
                },
                cellClasses:{
                },
                columnsDropdown:false,
                headings: {
                    Id: '#',
                    Fecha: 'Fecha Hora Registro',
                    Gestor: 'Usuario',
                },
                columnsClasses: {
                    Id: 'text-center font-bold text-danger',
                    Producto: 'text-center',
                    Gestor: 'text-center',
                    Tienda: 'text-center',
                    Area: 'text-center',
                    Formato: 'text-center',
                    Canal: 'text-center',
                    Cadena: 'text-center',
                    Fecha: 'text-center',
                    Comentario: 'text-justify',
                },
                texts: {
                    count: "Mostrando {from} al {to} de {count} registros|{count} registros|Un registro",
                    first: 'Primero',
                    last: 'Último',
                    filter: "Filtro:",
                    filterPlaceholder: "Buscar:",
                    limit: "Registros:",
                    page: "Pagína:",
                    noResults: "No hay resultados",
                    filterBy: "Filtrar",
                    loading: 'Buscando...',
                    defaultOption: 'Todos',
                    //defaultOption: 'Elige {column}',
                    columns: 'Columnas'
                },
            },
        }
    },
    mounted() {
        this.$refs.filtersReport.shows.trades = false;
        this.$refs.filtersReport.shows.marcas = false;
        this.$refs.filtersReport.shows.productos = false;
    },
    methods:{
        keyboardEvent (e) {
            if (e.which === 13) {
                this.getReportAnaquel();
            }
        },
        getReportAnaquel(){ let $this = this;
            var filters = this.$refs.filtersReport.filters;
            if (filters.timeInit === null){
                this.$toastMessage('error',"Fecha Inicio Es Obligatoria",4000,'center');
            }else if (filters.timeEnd === null){
                this.$toastMessage('error',"Fecha Termino Es Obligatoria",4000,'center');
            }else{
                this.loadingGetDataAnaquel = true;
                this.showDataAnaquel = false;
                this.showResultAnaquel = false;
                this.tableDataInventario = [];
                axios.post('/api/Anaquel/Tabla',{data:filters})
                    .then(r => {
                            $this.loadingGetDataAnaquel = false;
                            $this.showDataAnaquel = true;
                            $this.tableDataAnaquel = r.data.Data;
                            $this.showResultAnaquel = true;
                        },
                        error => {
                            $this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');
                        }
                    );
            }
        },
        ExportFileAnaquel(){let $this = this;
            this.loadfileAnaquel = true;
            var filters = this.$refs.filtersReport.filters;
            axios({
                method: 'post',
                url: '/api/Anaquel/exportLayoutToExcel',
                responseType: 'arraybuffer',
                data: {data: filters}}).then(r => {
                    let blob = new Blob([r.data], { type: 'application/xlsx' })
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = 'AnaquelMoet.xlsx'
                    link.click()
                    $this.loadfileAnaquel=false;
                },
                error => {
                    $this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');
                    $this.loadfileAnaquel=false;
                }
            );
        },
    }
}
</script>

<style scoped>

</style>
